import type { GridRequest } from "./contracts";

export const gridQueryKeys = {
  portfolios: () => ["portfolios"] as const,
  deliveryDays: () => ["delivery-days"] as const,
  positions: ({ deliveryDate, portfolioDa, portfolioId }: GridRequest) =>
    ["grid", deliveryDate, portfolioDa, portfolioId] as const,
};

export function buildGridRequestPath({
  deliveryDate,
  portfolioDa,
  portfolioId,
}: GridRequest): string {
  const params = new URLSearchParams({ deliveryDate });
  if (portfolioDa) params.set("portfolioDa", portfolioDa);
  if (portfolioId) params.set("portfolioId", portfolioId);
  return `/positions/grid?${params.toString()}`;
}
